/**
 * Map hotspot positions between container % and media-content % for object-fit contain/cover.
 * Stored x/y are always relative to the visible media box (0–100).
 */

export function getObjectFitContentRect(containerW, containerH, mediaW, mediaH, fit = "contain") {
  const cw = Number(containerW) || 0;
  const ch = Number(containerH) || 0;
  const mw = Number(mediaW) || 0;
  const mh = Number(mediaH) || 0;
  if (!cw || !ch || !mw || !mh) {
    return { x: 0, y: 0, width: cw || 1, height: ch || 1 };
  }

  const containerAspect = cw / ch;
  const mediaAspect = mw / mh;

  if (fit === "cover") {
    if (mediaAspect > containerAspect) {
      const height = ch;
      const width = ch * mediaAspect;
      return { x: (cw - width) / 2, y: 0, width, height };
    }
    const width = cw;
    const height = cw / mediaAspect;
    return { x: 0, y: (ch - height) / 2, width, height };
  }

  // contain
  if (mediaAspect > containerAspect) {
    const width = cw;
    const height = cw / mediaAspect;
    return { x: 0, y: (ch - height) / 2, width, height };
  }
  const height = ch;
  const width = ch * mediaAspect;
  return { x: (cw - width) / 2, y: 0, width, height };
}

export function clientPointToMediaPercent(
  clientX,
  clientY,
  containerRect,
  mediaW,
  mediaH,
  fit = "contain"
) {
  if (!containerRect?.width || !containerRect?.height) {
    return { x: 50, y: 50 };
  }
  const content = getObjectFitContentRect(
    containerRect.width,
    containerRect.height,
    mediaW,
    mediaH,
    fit
  );
  const localX = clientX - containerRect.left - content.x;
  const localY = clientY - containerRect.top - content.y;
  const x = (localX / content.width) * 100;
  const y = (localY / content.height) * 100;
  return {
    x: Math.min(100, Math.max(0, x)),
    y: Math.min(100, Math.max(0, y)),
  };
}

/** Returns { left, top } as CSS percentage strings for a positioned hotspot marker. */
export function mediaPercentToContainerCss(
  xPct,
  yPct,
  containerW,
  containerH,
  mediaW,
  mediaH,
  fit = "cover"
) {
  const cw = Number(containerW) || 1;
  const ch = Number(containerH) || 1;
  const content = getObjectFitContentRect(cw, ch, mediaW, mediaH, fit);
  const px = content.x + (Number(xPct) / 100) * content.width;
  const py = content.y + (Number(yPct) / 100) * content.height;
  return {
    left: `${(px / cw) * 100}%`,
    top: `${(py / ch) * 100}%`,
  };
}
